import { render, staticRenderFns } from "./LancamentoDeFrequenciaPage.vue?vue&type=template&id=c8620ae2&scoped=true&"
import script from "./LancamentoDeFrequenciaPage.vue?vue&type=script&lang=js&"
export * from "./LancamentoDeFrequenciaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8620ae2",
  null
  
)

export default component.exports